import { Box, Card, CardContent, TextField, Button, Typography, Alert, Link } from '@mui/material';
import { PointOfSale, ArrowBack } from '@mui/icons-material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams, Link as RouterLink } from 'react-router-dom';
import api from '../../api/axios';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const onSubmit = async ({ password }) => {
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    if (!token || !email) { setErr('Invalid reset link'); return; }

    setLoading(true); setErr('');
    try {
      await api.post('/auth/reset-password', { email, token, password });
      navigate('/login', { state: { message: 'Password reset successfully! Please login.' } });
    } catch (e) {
      setErr(e.response?.data?.message || 'Reset failed. Link may be expired.');
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Card sx={{ maxWidth: 420, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, bgcolor: 'primary.main', borderRadius: 3, mb: 2 }}>
              <PointOfSale sx={{ color: 'white', fontSize: 28 }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>Set New Password</Typography>
          </Box>

          {err && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{err}</Alert>}

          <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <TextField
              fullWidth label="New Password" margin="normal" type="password"
              error={!!errors.password} helperText={errors.password?.message}
              {...register('password', {
                required: 'Password is required',
                minLength: { value: 8, message: 'Minimum 8 characters' },
                pattern: { value: /^(?=.*[A-Z])(?=.*\d)/, message: 'Must include uppercase letter and number' },
              })}
            />
            <TextField
              fullWidth label="Confirm Password" margin="normal" type="password"
              error={!!errors.confirm} helperText={errors.confirm?.message}
              {...register('confirm', { validate: v => v === watch('password') || 'Passwords do not match' })}
            />
            <Button fullWidth variant="contained" type="submit" disabled={loading} size="large" sx={{ py: 1.5, mt: 2 }}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </Button>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Link component={RouterLink} to="/login" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
              <ArrowBack fontSize="small" /> Back to Login
            </Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
